/* ============================================================
   CORREÇÃO DEFINITIVA DAS VARIANTES SHOPIFY
   Corrige o problema em que G/GG visualmente selecionado
   continua enviando o ID da variante M.
   ============================================================ */

(function () {
  "use strict";

  /*
   * Localiza a variante correta através das opções selecionadas.
   */
  function sincronizarVariante(form) {
    if (!form) {
      return;
    }

    var radiosSelecionados = Array.from(
      form.querySelectorAll(
        ".product-form__single-selector:checked"
      )
    );

    if (!radiosSelecionados.length) {
      radiosSelecionados = Array.from(
        form.querySelectorAll(
          "input[type='radio'][data-option-position]:checked"
        )
      );
    }

    if (!radiosSelecionados.length) {
      return;
    }

    radiosSelecionados.sort(function (a, b) {
      return (
        parseInt(a.dataset.optionPosition || "1", 10) -
        parseInt(b.dataset.optionPosition || "1", 10)
      );
    });

    var valoresSelecionados =
      radiosSelecionados.map(function (radio) {
        return radio.value.trim();
      });

    var campoVariante = form.querySelector(
      "input[name='id']"
    );

    if (!campoVariante) {
      console.error(
        "VARIANTE: campo input[name='id'] não encontrado."
      );
      return;
    }

    /*
     * O produto JSON da Shopify contém todos os IDs reais
     * das variantes e suas opções.
     */
    fetch(window.location.pathname + ".js", {
      credentials: "same-origin",
      headers: {
        Accept: "application/json"
      }
    })
      .then(function (resposta) {
        if (!resposta.ok) {
          throw new Error(
            "Não foi possível carregar as variantes do produto."
          );
        }

        return resposta.json();
      })
      .then(function (produto) {
        var varianteCorreta =
          produto.variants.find(function (variante) {
            if (!variante.options) {
              return false;
            }

            return variante.options.every(function (
              valorDaVariante,
              indice
            ) {
              return (
                valoresSelecionados[indice] ===
                valorDaVariante.trim()
              );
            });
          });

        if (!varianteCorreta) {
          console.error(
            "VARIANTE: nenhuma variante encontrada para:",
            valoresSelecionados
          );
          campoVariante.value = "";
          return;
        }

        /*
         * Aqui está a correção principal:
         * atualiza o ID real da variante escolhida.
         */
        campoVariante.value = varianteCorreta.id;
        campoVariante.setAttribute(
          "value",
          varianteCorreta.id
        );

        campoVariante.dispatchEvent(
          new Event("input", {
            bubbles: true
          })
        );

        campoVariante.dispatchEvent(
          new Event("change", {
            bubbles: true
          })
        );

        /*
         * Atualiza o texto visual do tamanho selecionado.
         */
        var textoSelecionado = form.querySelector(
          ".product-form__selected-value"
        );

        if (textoSelecionado) {
          textoSelecionado.textContent =
            valoresSelecionados.join(" / ");
        }

        console.log(
          "VARIANTE CORRETA:",
          varianteCorreta.title,
          "ID:",
          varianteCorreta.id
        );
      })
      .catch(function (erro) {
        console.error(
          "ERRO AO SINCRONIZAR VARIANTE:",
          erro
        );
      });
  }


  /*
   * Quando o cliente altera o tamanho.
   */
  document.addEventListener(
    "change",
    function (evento) {
      var radio = evento.target.closest(
        ".product-form__single-selector, input[type='radio'][data-option-position]"
      );

      if (!radio) {
        return;
      }

      var form = radio.closest(
        "form"
      );

      if (!form) {
        form = radio.closest(
          ".product-form"
        );
      }

      setTimeout(function () {
        sincronizarVariante(form);
      }, 50);
    }
  );


  /*
   * Alguns temas alteram o radio pelo clique no label,
   * sem disparar corretamente o change.
   */
  document.addEventListener(
    "click",
    function (evento) {
      var label = evento.target.closest(
        "label"
      );

      if (!label) {
        return;
      }

      var radioId = label.getAttribute(
        "for"
      );

      if (!radioId) {
        return;
      }

      var radio = document.getElementById(
        radioId
      );

      if (!radio) {
        return;
      }

      var form = radio.closest(
        "form"
      );

      if (!form) {
        form = radio.closest(
          ".product-form"
        );
      }

      setTimeout(function () {
        sincronizarVariante(form);
      }, 100);
    }
  );


  /*
   * Também impede que o botão envie uma variante antiga.
   */
  document.addEventListener(
    "submit",
    function (evento) {
      var form = evento.target;

      if (!form || !form.querySelector) {
        return;
      }

      var campoVariante = form.querySelector(
        "input[name='id']"
      );

      if (!campoVariante) {
        return;
      }

      console.log(
        "ID ENVIADO AO CARRINHO:",
        campoVariante.value
      );
    },
    true
  );
})();
